module.exports = __webpack_public_path__ + "static/media/illustration_landing-characters.048b7ce1.svg";